import React from "react";
import VendorRegistration from "./vendorCode/VendorRegistration";
import { Stack, Typography } from "@mui/material";

const ForgetPassword = () => {
  return (
    <Stack
      sx={{ width: "100%", marginLeft: "20px", marginTop: "60px" }}
      spacing={3}
    >
      <Stack
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "start",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "darkslategray",
            fontWeight: 600,
            textTransform: "uppercase",
            marginLeft: "45px",
          }}
        >
          Forgot password ?
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "darkslategray",
            marginBottom: "-30px",
            fontSize: "14px",
          }}
        >
          Enter the vendor code associated with this account
        </Typography>
      </Stack>
      <VendorRegistration isForgetPassword={true} />
    </Stack>
  );
};

export default ForgetPassword;
